import { apiRequest, SUPABASE_URL } from "./apiUtils";
import { OrderDocument } from "@/models";

export const orderDocumentApi = {
  /**
   * Get a specific order document
   */
  async getById(orderDocumentId: number): Promise<OrderDocument> {
    try {
      const url = `${SUPABASE_URL}/order-documents/${orderDocumentId}`;
      return await apiRequest<OrderDocument>(url);
    } catch (error) {
      console.error(`Error fetching order document ${orderDocumentId}:`, error);
      throw error;
    }
  },

  /**
   * Update the release status of an order document
   */
  async updateReleaseStatus(
    orderDocumentId: number,
    released: boolean,
    pdfBase64?: string | null,
    opts?: { scheduledFor?: string; useScheduledPdf?: boolean }
  ): Promise<OrderDocument> {
    try {
      const url = `${SUPABASE_URL}/order-documents/${orderDocumentId}/release`;
      const body: any = { released };

      // Include PDF data if provided
      if (pdfBase64) {
        body.pdf_data = pdfBase64;
      }
      // Hold the delivery until the promised date, or send the PDF stored
      // when the release was scheduled.
      if (opts?.scheduledFor) body.scheduled_for = opts.scheduledFor;
      if (opts?.useScheduledPdf) body.use_scheduled_pdf = true;

      return await apiRequest<OrderDocument>(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
    } catch (error) {
      console.error(
        `Error updating release status for order document ${orderDocumentId}:`,
        error
      );
      throw error;
    }
  },

  /**
   * Update the uploaded file path of an order document
   */
  async updateUploadedFilePath(
    orderDocumentId: number,
    uploadedFilePath: string | null
  ): Promise<OrderDocument> {
    try {
      const url = `${SUPABASE_URL}/order-documents/${orderDocumentId}/upload`;
      return await apiRequest<OrderDocument>(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ uploaded_file_path: uploadedFilePath }),
      });
    } catch (error) {
      console.error(
        `Error updating uploaded file path for order document ${orderDocumentId}:`,
        error
      );
      throw error;
    }
  },
};
